// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form {
  width: 100%;
}

.login-form__field {
  margin-bottom: 16px;
}

.login-form__actions {
  margin-top: 24px;
}

.email-input {
  text-transform: lowercase;
}

.input-item.has-error {
  border-color: var(--input-error-color) !important;
  box-shadow: 0 0 0 1px var(--input-error-color);
}

.input-item.is-valid {
  border-color: var(--input-success-color) !important;
}

.custom-logo {
  width: 200px;
  margin: 0 auto;
  display: block;
}

.login-subtitle,
.input-label-text {
  color: #908B99;
}

.not-have-acc {
  position: absolute;
  bottom: 10px;
  text-decoration: none;
}

.timer {
  margin-top: 10px;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  font-weight: bold;
  text-align: center;
}

.custom-input {
  color: var(--label-login-color);
  padding-left: 10px !important;
  height: 3rem;
  margin: auto;
  display: inline-block;
  border-radius: 5px;
}

.custom-btn {
  color: rgba(0, 0, 0, 0.65);
  background: #ffffff;
  height: 41px;
  width: 100%;
}

.login-text {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.65);
  font-size: 1.2em;
}

.login-btn {
  color: #000000;
  font-weight: 300;
  height: 38px;
  font-size: 1em;
  padding: 10px;
}

.forgot-password {
  font-size: 14px;
  padding-left: 3px;
  text-decoration: underline;
  font-family: "Roobert-Regular";
  cursor: pointer;
}

.invalid-code {
  font-size: 0.8em;
  color: #dd2222;
  font-weight: bold;
  text-align: center;
  margin: 4px 0 0;
  font-family: "Roobert-Regular";
}

.timer {
  font-size: 0.8em;
  font-weight: bold;
  text-align: center;
}

.term-conditions {
  background-color: transparent;
  border: none;
  font-size: 0.78em;
  display: flex;
  align-items: center;
}

.footer {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0;
}

.footer-txt {
  font-size: 0.7em;
}

.spinner svg {
  width: 16px !important;
  height: 16px !important;
}

.text-center {
  text-align: center;
}

.btn-default {
  height: 3rem;
  width: 100%;
  max-width: none;
  font-family: "Roobert-Bold";
}

ion-checkbox {
  width: 33px;
  height: 21px;
  --border-radius: 4px;
}

.color-1st-screen .forgot-password {
  color: rgba(255, 255, 255, 0.85);
}

@media screen and (min-width: 768px) {
  .forgot-password {
    color: var(--text-color-2nd-login-desktop);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/login-without-code-confirm/login-without-code-confirm.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,iDAAA;EACA,8CAAA;AACF;;AAEA;EACE,mDAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;;EAEE,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,+BAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,0BAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,8BAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,8BAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE;IACE,0CAAA;EACF;AACF","sourcesContent":[".login-form {\n  width: 100%;\n}\n\n.login-form__field {\n  margin-bottom: 16px;\n}\n\n.login-form__actions {\n  margin-top: 24px;\n}\n\n.email-input {\n  text-transform: lowercase;\n}\n\n.input-item.has-error {\n  border-color: var(--input-error-color) !important;\n  box-shadow: 0 0 0 1px var(--input-error-color);\n}\n\n.input-item.is-valid {\n  border-color: var(--input-success-color) !important;\n}\n\n.custom-logo {\n  width: 200px;\n  margin: 0 auto;\n  display: block;\n}\n\n.login-subtitle,\n.input-label-text {\n  color: #908B99;\n}\n\n.not-have-acc {\n  position: absolute;\n  bottom: 10px;\n  text-decoration: none;\n}\n\n.timer {\n  margin-top: 10px;\n  font-size: .8em;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: bold;\n  text-align: center;\n}\n\n.custom-input {\n  color: var(--label-login-color);\n  padding-left: 10px!important;\n  height: 3rem;\n  margin: auto;\n  display: inline-block;\n  border-radius: 5px;\n}\n\n.custom-btn {\n  color: rgba(0, 0, 0, 0.65);\n  background: #ffffff;\n  height: 41px;\n  width: 100%;\n}\n\n.login-text {\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 1.2em;\n}\n\n.login-btn {\n  color: #000000;\n  font-weight: 300;\n  height: 38px;\n  font-size: 1em;\n  padding: 10px;\n}\n\n.forgot-password {\n  font-size: 14px;\n  padding-left: 3px;\n  text-decoration: underline;\n  font-family: 'Roobert-Regular';\n  cursor: pointer;\n}\n\n.invalid-code {\n  font-size: 0.8em;\n  color: #dd2222;\n  font-weight: bold;\n  text-align: center;\n  margin: 4px 0 0;\n  font-family: 'Roobert-Regular';\n}\n\n.timer {\n  font-size: 0.8em;\n  font-weight: bold;\n  text-align: center;\n}\n\n.term-conditions {\n  background-color: transparent;\n  border: none;\n  font-size: .78em;\n  display: flex;\n  align-items: center;\n}\n\n.footer {\n  width: 100%;\n  text-align: center;\n  position: absolute;\n  bottom: 0;\n}\n\n.footer-txt {\n  font-size: .7em;\n}\n\n.spinner svg {\n  width: 16px !important;\n  height: 16px !important;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.btn-default {\n  height: 3rem;\n  width: 100%;\n  max-width: none;\n  font-family: 'Roobert-Bold';\n}\n\nion-checkbox {\n  width: 33px;\n  height: 21px;\n  --border-radius: 4px;\n}\n\n.color-1st-screen .forgot-password {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n@media screen and (min-width: 768px) {\n  .forgot-password {\n    color: var(--text-color-2nd-login-desktop);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
